// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view-startup-admin-resources[data-v-4ff99ece]{flex:1 1 auto}", ""]);
// Exports
module.exports = exports;
